import { Text, TextStyles, designTokens } from '@cinch-labs/design-system'
import { SVG } from '@cinch-nx/shared-ui'
import cx from 'classnames'

import { Car } from '../../../../assets'
import styles from './holding-image.module.css'

const { space } = designTokens.customProperties.ds

const HoldingImage: React.FC<{
  text?: string
  isAvailable?: boolean
}> = ({ text = '', isAvailable }) => (
  <div
    className={cx(styles.holdingImage, {
      [styles.holdingImageUnavailable]: !isAvailable,
    })}
  >
    <SVG
      className={styles.icon}
      children={Car}
      fill={'currentColor'}
      size={space['8-x']}
    />

    {text && <Text type={TextStyles.menuTitle}>{text}</Text>}
  </div>
)

export default HoldingImage
